/*
 * Copyright (C) Serfim TIC
 * All rights reserved
 */
import { Filter } from '../../../model/Filter';
import { Command } from '../../../model/Command';
import { BaseController } from '../../BaseController';
import { ListController } from '../../ListController';

class AlarmSourceListController extends ListController {
    /** @ngInject */
    constructor(alarmSourceService, waitSpinnerService, $q, $state, $stateParams, $log, notificationService,
        configuration, filterService, dialogService, $scope) {
        super(configuration, notificationService, waitSpinnerService, $state, $stateParams, $q, $log);
        this.alarmSourceService = alarmSourceService;
        this.filterService = filterService;
        this.dialogService = dialogService;
        this.$scope = $scope;
        // mdDataTable doesn't support ES6 syntax with $ctrl variable in templates. That's why we must attach the reload
        // callback to the scope with an arrow function so as it can be called by this component with the correct 'this'
        // binding.
        this.$scope.reload = () => this.reload();
        this.$log.debug('Controller \'AlarmSourceList\' loaded');
    }

    $onInit() {
        super.$onInit();

        this.paging.sort = 'name';
        this.commands = [];
        this.initFilters();

        this.reload().then(() => this.initCommands());
    }

    /**
     * Initializes the filters available at the top of the view.
     */
    initFilters() {
        this.filters.push(
            Filter.emptyLikeFilter('name', 'model.alarmsource.name'),
            Filter.emptyLikeFilter('code', 'model.alarmsource.code'),
            Filter.booleanFilter('system', 'model.alarmsource.system', false)
        );
    }

    /**
     * Initializes the commands available in the view header.
     */
    initCommands() {
        this.commands.push(
            Command.stateCommand('ui.alarmsource.create', 'images/svg/add.svg', 'gmao.alarm.source.create'),
            Command.handlerCommand(undefined, 'images/svg/reset.svg', () => this.reload())
        );
    }

    /**
     * Reloads the list of alarm sources.
     *
     * @return {Promise} A promise providing the list of alarm sources.
     */
    reload() {
        return this.handleRestServiceCall(
            this.alarmSourceService.searchEntities({
                params: this.filterService.buildPagingParams(this.paging),
                data: this.filterService.buildFilters(this.filters)
            }),
            data => {
                this.model.data = data.content;
                this.model.totalElements = data.totalElements;
            }
        );
    }

    /**
     * Shows a confirmation dialog before deleting an alarm source. If the dialog is confirmed, the source is
     * deleted.
     *
     * @param {integer} id ID of the alarm source.
     * @return {Promise} A promise containing the confirmation result.
     */
    showDeleteConfirmationDialog(id) {
        return this.dialogService.showConfirmationDialogWithMessage('ui.alarmsource.deleteconfirmation').then(
            confirmed => {
                if (confirmed) {
                    this.deleteAlarmSource(id);
                }
                return confirmed;
            }
        );
    }

    /**
     * Deletes immediately an alarm source without confirmation, and reloads the list of sources.
     *
     * @param {integer} id ID of the alarm source.
     */
    deleteAlarmSource(id) {
        return this.handleRestServiceCall(this.alarmSourceService.deleteEntity(id), () => {
            this.notificationService.pushMessage('ui.alarmsource.deleted',
                this.configuration.NOTIFIER_LEVEL_INFO);
            this.reload();
        });
    }
}

export const alarmSourceListComponent = {
    template: require('./alarmsource-list.html'),
    controller: AlarmSourceListController
};



// WEBPACK FOOTER //
// ./src/main/front/scripts/module/alarm/component/AlarmSourceList.js